import { render } from "./FilterPresetConfig.vue?vue&type=template&id=cc6a9b0a"
import script from "./FilterPresetConfig.vue?vue&type=script&lang=js"
export * from "./FilterPresetConfig.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__